import React, { useEffect } from "react";
import { UserProvider } from "./components/UserContext";
import { AppRouter } from "./router/AppRouter";
import { ReactErrorBoundary } from "./components/ErrorBoundary";
import { Toaster } from "./components/ui/sonner";
import socketService from "./services/socket";

export default function App() {
  useEffect(() => {
    // Initialize Socket.IO connection
    const token = localStorage.getItem('token');
    
    console.log('App.tsx: Checking token...', token ? 'Token exists' : 'No token found');
    
    if (token) {
      console.log('App.tsx: Initializing Socket.IO connection...');
      try {
        const socket = socketService.connect(token);
        console.log('App.tsx: Socket instance created:', socket?.id || 'No ID yet');
        
        // Check connection after a delay
        setTimeout(() => {
          console.log('App.tsx: Connection status after 2s:', socketService.isConnected());
        }, 2000);
      } catch (error) {
        console.error('App.tsx: Error connecting socket:', error);
      }
    } else {
      console.warn('App.tsx: No token found, skipping socket connection');
    }

    // Cleanup on unmount
    return () => {
      if (socketService.isConnected()) {
        console.log('App.tsx: Disconnecting Socket.IO...');
        socketService.disconnect();
      }
    };
  }, []);

  return (
    <ReactErrorBoundary>
      <UserProvider>
        <AppRouter />
        <Toaster />
      </UserProvider>
    </ReactErrorBoundary>
  );
}
